
import Component from "../../../assets/outline/Component.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ComponentIcon({ className, dataTestid = "ComponentIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Component data-testid={dataTestid} className={classes} {...rest} />
  );
}
